import React from 'react';
import ListingPreview from '../../../shared/templates/ListingTemplate/listing-preview';

export default function TravelPreview(props) {
  return (
    <ListingPreview {...props} section="travel" />
  );
}